<template>
  <!-- ADD STAFF -->
  <v-layout
    row
    justify-center
  >
    <v-dialog
      v-model="addEditCustomerSubscriptionModal"
      persistent
      max-width="600px"
    >
      <v-card>
        <form
          action=""
          @submit.prevent="submitForm()"
        >
          <v-card-title>
            <v-flex
              xs11
              sm11
              md11
            ><span class="headline">{{ addEditData.user_subscription_id ? $t('common.edit') : $t('common.add') }} {{ $t('addEditUserSubscription.customerSubscriptionTitle') }}</span></v-flex>
            <v-flex
              xs1
              sm1
              md1
            >
              <v-btn
                flat
                @click="closeAddEditCustomerSubscriptionModal(), $validator.reset()"
                class="close"
              ><span aria-hidden="true">
              <i class="material-icons" style="font-size: 24px;vertical-align: middle;">close</i>
            </span></v-btn>
            </v-flex>
          </v-card-title>
          <v-card-text>
            <v-alert
              type="success"
              :value="checkAlert"
            >
              {{ $t('user.staffAddedSuccessfully') }}
            </v-alert>
            <v-layout wrap>
              <v-flex
                  class="px-2"
                  xs12
                  sm12
                  md12
                >
                  <v-select
                    autocomplete
                    :items="customers"
                    item-value="value"
                    item-text="text"
                    v-model="addEditData.customer_id_fk"
                    :error-messages="errors.collect('customer_id_fk')"
                    data-vv-name="customer_id_fk"
                    :label="$t('columns.customer') + '*'"
                    v-validate="'required'"
                    single-line
                    :disabled="!!addEditData.user_subscription_id"
                  >
                  </v-select>
              </v-flex>
              <v-flex
                xs12
                md12
                class="px-2"
              >
                <v-select
                  :items="warehouses"
                  item-value="value"
                  v-model="addEditData.warehouse_id_fk"
                  :error-messages="errors.collect('Warehouse')"
                  data-vv-name="Warehouse"
                  :label="$t('columns.warehouse') + '*'"
                  v-validate="'required'"
                  multiple
                  chips
                  deletable-chips
                  :disabled="!!addEditData.user_subscription_id"
                >
                </v-select>
              </v-flex>
              <v-flex
                  class="px-2"
                  xs12
                  sm12
                  md12
                >
                  <v-select
                    autocomplete
                    :items="orderTypes"
                    item-value="value"
                    v-model="addEditData.order_type_id_fk"
                    :error-messages="errors.collect('order_type_id_fk')"
                    data-vv-name="order_type_id_fk"
                    :label="$t('columns.orderType') + '*'"
                    v-validate="'required'"
                    multiple
                    chips
                    deletable-chips
                    :disabled="!!addEditData.user_subscription_id"
                  >
                  </v-select>
              </v-flex>
              <v-flex
                  class="px-2"
                  xs12
                  sm12
                  md12
                >
                  <v-select
                    autocomplete
                    :items="subscriptions"
                    item-value="value"
                    v-model="addEditData.subscription_id"
                    :error-messages="errors.collect('subscription_id')"
                    data-vv-name="subscription_id"
                    :label="$t('columns.subscription') + '*'"
                    v-validate="'required'"
                    single-line
                  >
                  </v-select>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              style="height:auto"
              @click="closeAddEditCustomerSubscriptionModal(), $validator.reset()"
              outline
              color="normal"
            >{{ $t('common.cancel') }}</v-btn>
            <v-btn
              type="submit"
              style="height:auto" class="rtl-mr-3pct"
              outline
              color="success"
            >{{ $t('common.save') }}</v-btn>
          </v-card-actions>
        </form>
      </v-card>
    </v-dialog>
  </v-layout>
  <!-- /ADD Edit Customer Subscription -->
</template>

<script>
import axios from 'axios'

export default {
  props: [
    'warehouses',
    'orderTypes',
    'addEditData',
    'addEditCustomerSubscriptionModal',
    'submitAddEditUserSubscription',
    'checkAlert',
    'customers',
    'subscriptions',
    'closeAddEditCustomerSubscriptionModal',
    'validationError'
  ],

  data() {
    return {
    }
  },

  methods: {
    submitForm(event) {
      this.$validator.validateAll().then(res => {
        if (res) {
          this.submitAddEditUserSubscription()
        }
      })
    }
  }
}
</script>

<style>
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}
.dialog-dialog--active-dialog--persistent {
  opacity: 1 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}
.dialog {
  box-shadow: 0 3px 5px -1px rgba(14, 14, 14, 0.212) !important;
  overflow: hidden !important;
  overflow-y: auto !important;
}
.dialog:not(.dialog--fullscreen) {
  max-height: 95%;
}
</style>



// WEBPACK FOOTER //
// src/components/user_subscription/addEditUserSubscription.vue